import {$body} from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';

/**
 * Shortcuts
 */
export default class Shortcuts {
  constructor($shortcuts) {
    this.$shortcuts = $shortcuts;

    this.bindHandlers();
    this.adjustBodyPadding();

    this.prevHeight = 0;
  }

  bindHandlers() {
    $('window').on('resize', () => {
      if (this.getHeight() !== this.prevHeight) {
        this.adjustBodyPadding();
      }
    });
  }

  getHeight() {
    return this.$shortcuts.outerHeight();
  }

  adjustBodyPadding() {
    $body.css('padding-bottom', this.getHeight());
    this.prevHeight = this.getHeight();
  }
}
